import { BulkMessageHooks } from '@frontend/bulk-message-service';

export const useShowBulkMessageButton = (): boolean => {
  const hasBulkMessaging = BulkMessageHooks.useHasBulkTexting();
  return hasBulkMessaging;
};
